import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import termsOfServiceDe from "./locales/de/terms-of-service.json";

export const defaultNS = "common";

const TERMS_OF_SERVICE_NS = "terms-of-service";

function addTermsOfServiceBundle(instance: ReturnType<typeof i18n.createInstance>, lng: string): void {
  if (lng === "de") {
    instance.addResourceBundle("de", TERMS_OF_SERVICE_NS, termsOfServiceDe as Record<string, string>, true, true);
  }
}

export const loadi18n = async (lng: string) => {
  const instance = i18n.createInstance();
  await instance
    .use(HttpApi)
    .use(initReactI18next)
    .init({
      lng: lng,
      fallbackLng: lng,
      debug: false,
      interpolation: {
        escapeValue: false,
      },
      ns: [],
      defaultNS,
    });
  addTermsOfServiceBundle(instance, lng);
  return instance;
};
